"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonProcessingResponse = void 0;
var lodash_1 = require("lodash");
/**
 * Ответ на запрос исполнения операции над сущностью
 *
 * NOTE: модель CommonProcessingResponse является наиболее полной моделью ответа от сервера, в которой
 * . предусмотрены как модель, так и сообщения об ошибках обработки, причём ошибка может быть общая
 * . + детально сообщения об ошибка валидации для свойств сущности или связанных сущностей
 */
var CommonProcessingResponse = /** @class */function () {
  function CommonProcessingResponse(values) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var instance = this;
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, this.getClassProperties()));
  }
  CommonProcessingResponse.prototype.captureException = function (err, details) {
    this.status = false;
    this.statusText = err.message;
    this.error = err.message;
    this.stack = err.stack;
    this.details = details || null;
    // if (err instanceof ValueValidationError) {
    //   response.validation...
    // }
  };
  CommonProcessingResponse.prototype.getClassProperties = function () {
    return ['status', 'statusText', 'model', 'error', 'stack', 'details', 'validation'];
  };
  return CommonProcessingResponse;
}();
exports.CommonProcessingResponse = CommonProcessingResponse;
